import { connect } from 'react-redux';
import Dashboard from './Dashboard';
import authSelector from 'modules/Auth/selectors';
import mandatesSelector from 'modules/Mandates/selectors';
import * as mandatesActions from 'modules/Mandates/actions';

const mapStateToProps = state => ({
  userData: authSelector?.getUserData(state),
  mandatesList: mandatesSelector.getMandatesList(state),
  singleMandate: mandatesSelector.getSingleMandate(state),
  loading: mandatesSelector.getMandatesLoading(state),
  mandateMetrics: mandatesSelector.getMandateMetrics(state),
});

const mapDispatchToProps = {
  getMandatesList: mandatesActions.getMandatesList,
  getSingleMandate: mandatesActions.getSingleMandate,
  createNewMandate: mandatesActions.createNewMandate,
  updateExistingMandate: mandatesActions.updateExistingMandate,
  deleteExistingMandate: mandatesActions.deleteExistingMandate,
  updateMandateCounts: mandatesActions.updateMandateCounts,
  getMandateMetrics: mandatesActions.getMandateMetrics,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
